module.exports = __webpack_public_path__ + "img/loby-farmacia-1-1024x576.91dd6469.jpg";